export const environment = {
  production: false,
  pwa: false,
  matomoSiteID: 47,
  url: 'https://youca-stage.nousdigital.net',
  baseUrl: 'https://cms-stage.nousdigital.net',
  authUrl: 'https://auth-stage.nousdigital.net',
  realm: 'nous-stage',
  clientId: 'pwa-youca',
  clientSecret: '7qkT9SZaS9OOhsU2BUnpOD8p8c2X4YUq',
  homeUrl: '/',
  contentUrl: 'https://cmsnous.blob.core.windows.net/youca-stage/content',
  urlSuffix: 'youca'
};
